import { TProductActionButton } from './ProductActionButton';
import { PAGE_LOAD_ACTION_TYPES } from 'core/product/PageLoadActionProcessor';
import { isBase64Encoded } from 'core/utils';

/**
 * @description StoreAvailabilityBtnClassCreator widget
 * @param Button ProductActionButton widget for extending
 * @returns StoreAvailabilityBtnClassCreator class
 */
function StoreAvailabilityBtnClassCreator(Button: TProductActionButton) {
    class StoreAvailabilityBtn extends Button {
        prefs() {
            return {
                signInModalUrl: '',
                signInModalTitle: '',
                ...super.prefs()
            };
        }

        /**
         * @description Override of the original submit that prepares all the data and displays the sign in
         * modal, which will then handle the store availability drawer opening after sign in
         */
        submit(): void {
            const modalURL = this.prefs().signInModalUrl;

            const modalParams = {
                url: isBase64Encoded(modalURL) ? atob(modalURL) : modalURL,
                headerText: this.prefs().signInModalTitle,
                wrapperClasses: 'm-sign_in_to_buy',
                pageLoadAction: {
                    type: PAGE_LOAD_ACTION_TYPES.STORE_AVAILABILITY,
                    data: this.getModalParams()
                }
            };

            this.eventBus().emit('signInToBuyModal.show', modalParams);
        }
    }

    return StoreAvailabilityBtn;
}

export type TStoreAvailabilityBtn = ReturnType<typeof StoreAvailabilityBtnClassCreator>;

export type TStoreAvailabilityBtnInstance = InstanceType<TStoreAvailabilityBtn>;

export default StoreAvailabilityBtnClassCreator;
